
import { BehaviorSubject } from 'rxjs';

export const behaviorUserAddressComponent$ = new BehaviorSubject({});

export const behaviorUserAddressComponent = behaviorUserAddressComponent$.asObservable();